// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__EzEp0","shade":"index_shade__FgBKL"};